import { confirm, handleMessages, load } from 'poly-eshop4/eshop/ui/js/util';


$(document).on('change', '[data-costing-type]', function() {
  $('[data-minimum-margin]').toggle($(this).val() === 'VP');
});

$(document).on('change', '[data-pricebase-pricelist]', function() {
  $('[data-minimum-margin]').toggle($(this).val() === '99');
});

$(document).on('change', '[data-minimum-margin-cb]', function() {
  const $el = $($(this).attr('data-minimum-margin-cb'));
  $el.get(0).disabled = !this.checked;
  if (!this.checked) {
    $el.val('');
  }
});

$(document).on('submit', '[data-cart-groups-setting]', function(event) {
  event.preventDefault();

  const $form = $(this);
  $.ajax({
    url: $form.attr('action'),
    type: 'POST',
    data: $form.serialize(),
  }).then(() => {
    $form.foundation('close');
  });
});

$(document).on('submit', '[data-category-item-add-form]', () => {
  $('[data-category-item-add-form-button] i').removeClass('icon-plus').addClass('loader');
  $('[data-category-item-add-form-button]').get(0).disabled = true;
});

$(document).on('change', '#id_unrestricted_reseller_collections', function() {
  // select all reseller collections if "unrestricted_reseller_collections" is checked
  if ($(this).is(':checked')) {
    $('[data-reseller-collections]').addClass('hide');
    $('#id_reseller_collections').find('option').each(function() {
      this.selected = true;
    });
  } else {
    $('[data-reseller-collections]').removeClass('hide');
  }
});

$(document).on('change', '#id_reseller_collections', () => {
  // uncheck "unrestricted_reseller_collections" if not all reseller collections are selected
  if ($('#id_reseller_collections').has('option:not(:selected)')) {
    $('#id_unrestricted_reseller_collections').get(0).checked = false;
  }
});

$(() => {
  // select all reseller collections on load, if "unrestricted_reseller_collections" is checked
  if ($('#id_unrestricted_reseller_collections').is(':checked')) {
    $('#id_reseller_collections').find('option').each(function() {
      this.selected = true;
    });
  }
});

$(document).on('click', '[data-multilingual-field] [data-multilingual-field-lang]', function(event) {
  event.preventDefault();
  const field = $(this).closest('[data-multilingual-field]');
  const lang = $(this).attr('data-multilingual-field-lang');
  field.find('[data-multilingual-field-lang]').each(function() {
    $(this).toggleClass('active', $(this).attr('data-multilingual-field-lang') === lang);
  });
});

$(document).on('change', '[data-costing-head-form]', function () {
  $(this).submit();
});

$(document).on('submit', '[data-costing-head-form]', function (event) {
  event.preventDefault();
  $.ajax({
    url: $(this).attr('action'),
    method: 'POST',
    data: $(this).serializeArray(),
  });
});

$(document).on('change', '[data-costing-head-all-form]', function () {
  $(this).submit();
});

$(document).on('submit', '[data-costing-head-all-form]', function (event) {
  event.preventDefault();
  const $this = $(this);
  $this.attr('data-confirm', $this.attr('data-costing-head-all-form'));

  confirm($this).then(({ confirmed, reveal }) => {
    $this.removeAttr('data-confirm');
    if (confirmed) {
      reveal.addClass('loading');
      $.ajax({
        url: $(this).attr('action'),
        method: 'POST',
        data: $(this).serializeArray(),
      }).then(handleMessages).then((result) => {
        if (result.status) {
          reveal.addClass('loaded');
          $('[data-costing-head]').val($(this).find('[data-costing-head]').val());
        }
        reveal.removeClass('loading loaded');
        reveal.foundation('close');
      });
    }
  }).catch(() => {});
});

$(document).on('change', '[data-pricematrix-item-costinghead]', function() {
  const $form = $(this).closest('form');
  const disabled = !!this.selectedIndex;
  $form.find('input:not([type="hidden"]):not([data-pricematrix-item-costinghead])').each(function() {
    this.disabled = disabled;
  });
});

$(document).on('submit', '[data-pricematrix-item-update-form]', function(event) {
  event.preventDefault();

  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');
  const promise = $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serialize(),
  }).then(handleMessages).then(() => {
    if ($form.attr('data-pricematrix-item-update-form') === 'verify') {
      document.location.reload();
    } else {
      setTimeout(() => $form.closest('[data-reveal]').foundation('close').remove(), 1500);
      $('input[form=itemlist]:first').trigger('change');
    }
  });

  if ($form.attr('data-pricematrix-item-update-form') === 'verify') {
    $reveal.addClass('loading');
  } else {
    load($reveal, promise, {
      errorClass: 'error',
    });
  }
});

$(document).on('submit', '[data-pricematrix-item-delete-form]', function(event) {
  event.preventDefault();

  const $form = $(this);
  $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serialize(),
  }).then(handleMessages).then(() => {
    $('input[form=itemlist]:first').trigger('change');
  });

  $form.addClass('loading');
});

$(document).on('submit', '[data-pricematrix-verify]', function() {
  if ($(this).is('.reveal')) {
    $(this).addClass('loading');
  } else {
    $(this).find('button').addClass('loading');
  }
});

$(document).on('submit', '[data-reseller-items-import]', function(event) {
  const $form = $(this).removeClass('error');
  const $msg = $form.find('[data-reseller-items-import-messages]').html('').hide().removeClass('alert');
  event.preventDefault();
  const data = new FormData($form[0]);

  const request = new XMLHttpRequest();
  const promise = $.ajax({
    url: $form.attr('action'),
    xhr: () => request,
    method: 'POST',
    data,
    contentType: false,
    processData: false,
  }).then(handleMessages);

  load(this, promise).then((result) => {
    if (result.has_errors === true) {
      $form.addClass('error');
      $msg.addClass('alert');
    }
    $msg.html(result.import_messages)[result.import_messages ? 'show' : 'hide']();
  });
});

$(document).on('click', '[data-close-reseller-items-import]', function() {
  $(this).closest('[data-reveal]').foundation('close');
  document.location.reload();
});

$(document).on('closeme.zf.reveal', '[data-reseller-items-import]', function() {
  $(this).removeClass('error');
  $(this).find('[data-reseller-items-import-messages]').html('').hide()
    .removeClass('alert');
});

$(document).on('submit', '[data-pricelist-publish]', function() {
  $(this).addClass('loading');
});

$(document).on('change', 'input[name="shipping_method"]', function() {
  const pickupAddresses = $('[data-pickup-addresses]');
  if (pickupAddresses) {
    pickupAddresses[$(this).val() === pickupAddresses.attr('data-pickup-addresses') ? 'show' : 'hide']();
  }
});

$(document).on('change', '[data-shipping-method-toggle]', function() {
  const sm = $(this).attr('data-shipping-method');
  const st = $(this).attr('data-shipping-type');
  $(`input[type="number"][data-shipping-method="${sm}"][data-shipping-type="${st}"]`).attr(
    'disabled',
    !$(this).is(':checked'),
  );
});

$(document).on('click', '[data-shipping-method-default-toggle]', function() {
  $('[data-shipping-method-default-toggle]').not(this).each(function() {
    this.checked = false;
  });
});

$(document).on('change', '[data-reseller-item] #id_item_number', function() {
  const itemId = $(this).val();
  const form = $(this).closest('[data-reseller-item]');

  $.ajax({
    url: form.attr('data-reseller-item'),
    method: 'GET',
    data: {
      item_id: itemId,
    },
  }).then((result) => {
    if (result.status === 'success' && result.item_id) {
      form.find('[data-reseller-item-warning]').html(result.message).addClass('is-visible');
    } else {
      form.find('[data-reseller-item-warning]').html('').removeClass('is-visible');
    }
  });
});

$(document).on('click', '[data-reseller-layout-copy]', function() {
  const $form = $(this).closest('form');
  $form.attr('data-confirm', $(this).attr('data-reseller-layout-copy'));

  confirm($form).then(({ confirmed, reveal }) => {
    $form.removeAttr('data-confirm');
    if (confirmed) {
      reveal.addClass('loading');
      const $copy = $form.find('input[name="copy"]');
      $copy.val(1);
      $form.submit();
      $copy.val(0);
    }
  }).catch(() => {});
});

$(document).on('change', '[data-reseller-orders-form]', function(event) {
  const $form = $(this);
  if (!event.target.value) {
    $form.find('[data-reseller-order-select]').prop('checked', event.target.checked);
  }
  $form.find('button[type="submit"]').prop('disabled', !$form.find('[data-reseller-order-select]:checked').length);
});

$(() => {
  if ($('[data-wysiwyg]').length) {
    require.ensure(['./editor'], (require) => {
      const tinymce = require('./editor').default;
      tinymce.init({
        selector: '[data-wysiwyg]',
        branding: false,
        base_url: '/static/js/tinymce',
        language: $('html').attr('lang').split('-')[0],
        plugins: ['table', 'link', 'paste', 'fullscreen'],
        menubar: 'edit insert view format table tools',
      });
    });
  }

  function updatePricematrixPricelists() {
    $.ajax($('[data-pricematrix-pricelists]').attr('data-pricematrix-pricelists')).then((html) => {
      $('[data-pricematrix-pricelists]').html(html);
      setTimeout(updatePricematrixPricelists, 10000);
    });
  }

  if ($('[data-pricematrix-pricelists]').length) {
    setTimeout(updatePricematrixPricelists, 10000);
  }

  if ($('[data-reseller-order-select]:checked').length) {
    $('[data-reseller-orders-form] button[type="submit"]').prop('disabled', false);
  }
});
